import {CircularProgress} from '@mui/material'
import React from 'react'
import NewJobApiError from '@/components/pages/NewDatasetJobPage/NewJobApiError'

type RemainingSampleCountProps = {
    loading: boolean
    error: boolean
    remainingSampleCount?: number
}

const RemainingSampleCount = ({loading, error, remainingSampleCount}: RemainingSampleCountProps) => {

    if(loading) {
        return <CircularProgress/>
    }

    if(error) {
        return <NewJobApiError text="Unable to load remaining sample count"/>
    }

    return <>{remainingSampleCount !== undefined ? remainingSampleCount : '-'}</>
}

export default RemainingSampleCount